import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await register(email, password, name);
      toast.success(`Account created. Welcome, ${u.name}`);
      nav(new URLSearchParams(window.location.search).get("next") || "/");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <main className="max-w-md mx-auto px-6 py-24" data-testid="register-page">
      <p className="overline opacity-60 mb-2">// Join the shop</p>
      <h1 className="font-display font-black text-4xl tracking-tighter mb-8">Create account</h1>
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <input className="input-sharp" placeholder="Full name" value={name}
               onChange={(e) => setName(e.target.value)} required data-testid="register-name" />
        <input className="input-sharp" type="email" placeholder="Email" value={email}
               onChange={(e) => setEmail(e.target.value)} required data-testid="register-email" />
        <input className="input-sharp" type="password" placeholder="Password (min 6)" value={password}
               onChange={(e) => setPassword(e.target.value)} required minLength={6} data-testid="register-password" />
        <button className="btn-signal w-full justify-center" disabled={loading} data-testid="register-submit">
          {loading ? "Creating…" : "Create account →"}
        </button>
      </form>
      <p className="font-mono text-sm mt-6 opacity-70">
        Already have an account? <Link to="/login" className="text-signal underline">Sign in</Link>
      </p>
    </main>
  );
}
